import { render, staticRenderFns } from "./scorecards.vue?vue&type=template&id=6306144a"
import script from "./scorecards.vue?vue&type=script&lang=js"
export * from "./scorecards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports